import {AbstraktniSoubor} from './abstraktni-soubor';

export class SouborFormulare extends AbstraktniSoubor {
	file: File;
}
